import api, { handleApiError } from './client';

export const rentableItemService = {
  /**
   * Get all rentable items with pagination and filters
   */
  getAll: async (page = 1, limit = 10, searchText = null, isActive = null) => {
    try {
      const response = await api.get('/api/rentable-items', {
        params: {
          page,
          limit,
          searchText: searchText || undefined,
          isActive: isActive !== null ? isActive : undefined,
        },
      });

      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching rentable items:', error);
      return handleApiError(error, 'Errore nel caricamento degli oggetti noleggiabili');
    }
  },

  /**
   * Get rentable item by ID
   */
  getById: async (id) => {
    try {
      const response = await api.get(`/api/rentable-items/${id}`);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error fetching rentable item:', error);
      return handleApiError(error, "Errore nel caricamento dell'oggetto noleggiabile");
    }
  },

  /**
   * Create new rentable item
   */
  create: async (itemData) => {
    try {
      const payload = {
        name: itemData.name,
        description: itemData.description || null,
        price: parseFloat(itemData.price),
        deposit: parseFloat(itemData.deposit),
        isActive: itemData.isActive !== false,
      };

      const response = await api.post('/api/rentable-items', payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error creating rentable item:', error);
      return handleApiError(error, "Errore nella creazione dell'oggetto noleggiabile");
    }
  },

  /**
   * Update rentable item
   */
  update: async (id, itemData) => {
    try {
      const payload = {
        id,
        name: itemData.name || null,
        description: itemData.description || null,
        price: itemData.price ? parseFloat(itemData.price) : null,
        deposit: itemData.deposit ? parseFloat(itemData.deposit) : null,
        isActive: itemData.isActive !== undefined ? itemData.isActive : null,
      };

      const response = await api.put(`/api/rentable-items/${id}`, payload);
      return { success: true, data: response.data };
    } catch (error) {
      console.error('Error updating rentable item:', error);
      return handleApiError(error, "Errore nell'aggiornamento dell'oggetto noleggiabile");
    }
  },

  /**
   * Delete rentable item
   */
  delete: async (id) => {
    try {
      await api.delete(`/api/rentable-items/${id}`);
      return { success: true };
    } catch (error) {
      console.error('Error deleting rentable item:', error);
      return handleApiError(error, "Errore nell'eliminazione dell'oggetto noleggiabile");
    }
  },
};

export default rentableItemService;
